import { getNumber } from '@pbk/get-number';
import { MONTHS_IN_YEAR } from '../consts';
export const monthsToYearsMonths = (months) => {
    const safeMonths = getNumber(months);
    return {
        years: Math.floor(safeMonths / MONTHS_IN_YEAR),
        months: Math.floor(safeMonths % MONTHS_IN_YEAR),
    };
};
export const yearsMonthsToMonths = ({ years, months }) => {
    return years * MONTHS_IN_YEAR + months;
};
